var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "fixed w-screen top-18 flex justify-end transition-all duration-500",
          style: {
            right: _vm.open ? "0vw" : "-100vw",
            height: "calc(100vh - 4.5rem)",
            zIndex: 51
          },
          attrs: { id: "edit-intruction-panel" }
        },
        [
          _c("div", {
            staticClass: "h-full w-screen absolute left-0 top-0 -z-10",
            on: {
              click: function($event) {
                return _vm.$emit("close-panel")
              }
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "h-full w-5 rounded-l-3xl flex-shrink-0 relative z-0",
            style: {
              background: "linear-gradient(180deg, #FFE4E8 0%, #9A8AC2 100%)"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "h-full w-120 flex-shrink-0 flex flex-col bg-pure-white relative z-0"
            },
            [
              _c(
                "div",
                { staticClass: "py-4 px-6 flex flex-col gap-1" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center justify-between" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative rounded-full flex-shrink-0 min-h-6 px-3 flex items-center",
                          class: [
                            _vm.stage.is_discontinued
                              ? "bg-rose-200"
                              : _vm.stage.is_admitted
                              ? "bg-lime-200"
                              : "bg-cornflower-200"
                          ]
                        },
                        [
                          _c("BlTextSubtitle3", {
                            class: [
                              _vm.stage.is_discontinued
                                ? "text-rose-700"
                                : _vm.stage.is_admitted
                                ? "text-lime-700"
                                : "text-cornflower-800"
                            ],
                            attrs: { text: _vm.stage.name }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.open
                        ? _c("BlIcon", {
                            staticClass: "h-6 w-6",
                            attrs: {
                              icon: "close",
                              color: "slate-6",
                              clickable: ""
                            },
                            on: {
                              clicked: function($event) {
                                return _vm.$emit("close-panel")
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextTitle4", { attrs: { text: "Stage instructions" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-6 py-4 rounded-t-3xl bg-light-purple-300" },
                [
                  _c("BlTextSubtitle2", {
                    staticClass: "text-pure-white",
                    attrs: { text: "Edit instruction" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "relative h-full flex flex-col justify-between overflow-y-auto"
                },
                [
                  _c(
                    "div",
                    { staticClass: "py-5 px-6 flex flex-col gap-3" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.titleInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _vm.open
                        ? _c(
                            "div",
                            { staticClass: "pb-px relative" },
                            [
                              _c("VueEditor", {
                                staticClass: "blum-editor",
                                attrs: {
                                  "editor-toolbar": _vm.customToolbar,
                                  placeholder: "Description"
                                },
                                model: {
                                  value: _vm.descriptionInput,
                                  callback: function($$v) {
                                    _vm.descriptionInput = $$v
                                  },
                                  expression: "descriptionInput"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploads.length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "p-2 flex flex-col gap-2 rounded bg-slate-200"
                            },
                            _vm._l(_vm.uploads, function(upload) {
                              return _c("BlFileHolder", {
                                key: upload.id,
                                attrs: {
                                  name: upload.blob.filename,
                                  size: upload.blob.byte_size,
                                  removeable: ""
                                },
                                on: {
                                  "remove-handler": function($event) {
                                    return _vm.openRemoveDoc(upload)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-center justify-between" },
                        [
                          _c("input", {
                            attrs: {
                              type: "file",
                              name:
                                "upload_document_stage_" + _vm.instruction.id,
                              id: "upload_document_stage_" + _vm.instruction.id,
                              hidden: ""
                            },
                            on: { change: _vm.onAddDoc }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-4" },
                            [
                              _vm.open
                                ? _c("BlInputButton", {
                                    attrs: {
                                      type: "plain",
                                      dense: "",
                                      icon: "plus",
                                      label: "Add document",
                                      loading: _vm.uploadFileLoading
                                    },
                                    on: { clicked: _vm.openUpload }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFileLoading
                                ? _c("div", { staticClass: "blum-loader-xs" })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.uploads.length
                            ? _c("BlTextBody2", {
                                attrs: {
                                  text: _vm.uploads.length + " file(s) added"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-18 px-6 pt-4 sticky bottom-0 flex-shrink-0 bg-pure-white grid grid-cols-3 gap-4"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex gap-4" },
                        [
                          _vm.open
                            ? _c("BlInputButton", {
                                attrs: { icon: "delete", type: "plain-error" },
                                on: {
                                  clicked: function($event) {
                                    _vm.deleteInstructionOpened = true
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: { label: "Close", type: "plain" },
                            on: {
                              clicked: function($event) {
                                return _vm.$emit("close-panel")
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "col-span-2",
                        attrs: {
                          label: "Update",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onUpdate }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.deleteFileOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete document",
                label: "Delete",
                type: "error",
                disabled: _vm.deleteFileLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteFileOpened = false
                },
                "backdrop-action": function($event) {
                  return _vm.onRemoveDoc(_vm.deleteFile)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "w-160 px-8" },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "You are about to delete " }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: _vm.deleteFile.blob.filename + ". " }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Are you sure you want to proceed? This action is irreversible."
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteInstructionOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete instruction",
                label: "Delete",
                type: "error",
                disabled: _vm.deleteInstructionLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteInstructionOpened = false
                },
                "backdrop-action": _vm.onRemove
              }
            },
            [
              _c(
                "div",
                { staticClass: "w-160 px-8" },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "You are about to delete " }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: _vm.instruction.title + ". " }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Are you sure you want to proceed? This action is irreversible."
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7456d647", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7456d647","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/EditInstructionStagePanel.vue
// module id = null
// module chunks = 